import { TPack } from '@/interfaces/packs';
import { getFileExtension, getFileExtensionByUrl } from './getFileExtension';
import { removeSpecialCharacters } from './removeSpecialCharacters';
import { clips, photos } from '@prisma/client';
import _ from 'lodash';
import { String } from 'aws-sdk/clients/acm';
import { v4 as uuidv4 } from 'uuid';

export interface FormatableFileName {
  pack: FormatableFileNamePack | null | undefined;
  file: File;
  assetId: number;
}

export interface FormatableFileNamePack {
  name: string;
  artist: {
    first_name: string | null;
    last_name: string | null;
  } | null;
}

function getDTSFileNamePrefix(project?: FormatableFileNamePack | null | undefined) {
  if (!project) return `DTS`;
  const parsedPackName = project?.name?.replace(/ /g, '_') || '';
  const artistFirstName = project?.artist?.first_name?.replace(/ /g, '_') || '';
  const artistLastName = project?.artist?.last_name?.replace(/ /g, '_') || '';
  const parsedArtistName = artistLastName
    ? `${artistFirstName}_${artistLastName}`
    : artistFirstName;
  return `DTS_${parsedPackName}_${parsedArtistName}`;
}
export function formatUploadFileName({ pack, file, assetId }: FormatableFileName) {
  const extension = getFileExtension(file);
  const dtsFileNamePrefix = getDTSFileNamePrefix(pack);
  return removeSpecialCharacters(`${dtsFileNamePrefix}_${assetId}.${extension}`);
}

export function formatUploadEchoFileName(file: File, id: number) {
  const extension = getFileExtension(file);
  return `DTS_Echos_${uuidv4()}_${id}.${extension}`;
}

export function formatPhotoDownloadName(photo: photos, project?: FormatableFileNamePack | null) {
  if (!project) return photo.name;
  const dtsFileNamePrefix = getDTSFileNamePrefix(project);
  return `${dtsFileNamePrefix}_Photo_ID${photo.id}`;
}

export function formatZipDownloadName(project: TPack) {
  const parsedPackName = project?.name?.replace(/ /g, '_') || '';
  const type = _.upperFirst(_.toLower(project.type));
  return `DTS_${parsedPackName}_${type}s.zip`;
}

export function formatMediaDownloadName(
  project: FormatableFileNamePack | null | undefined,
  media: (TPack | photos | clips) & { type: 'photo' | 'clip' | 'video' },
  downloadLink: String
) {
  const dtsFileNamePrefix = getDTSFileNamePrefix(project);
  const mediaType = _.upperFirst(_.toLower(media.type));
  const extension = getFileExtensionByUrl(downloadLink);
  return `${dtsFileNamePrefix}_${mediaType}s_ID${media.id}.${extension}`;
}

export async function downloadCrossOriginFile(url: string, filename: string) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const blob = await response.blob();

  const link = document.createElement('a');
  const blobUrl = URL.createObjectURL(blob);
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}
